import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useSelectorWithArgs = (selector, ...args) => {
    // Wrap the selector with a closure that includes the necessary arguments
    const select = useMemo(() => state => selector(state, ...args), [selector, ...args]);
    return useSelector(select);
};
